import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['٦ مجلدات', '٥ هدايا', '٢٤٠ صفحة', 'الأول ابتدائي – الثالث متوسط'];
const reassurances = ['تنزيل رقمي فوري', 'ملفات جاهزة للطباعة', 'ضمان رضا ٧ أيام'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15cklj0sfumel">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 right-4 w-px bg-red-300 sm:right-8 lg:right-12" data-id="element-115" data-mp="1jbtxtpdiwwda" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ebxtfp0wz2x7">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t1my3u87tp28">
          دروس الرياضيات يمكن أن تكون <em className="text-red-700" data-id="element-118" data-mp="1o5y5kaum58ff">جاهزة من اليوم.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="224eabw8x0oux">
          بدلًا من البحث عن أوراق العمل وإعداد كل تمرين بنفسك وقضاء ليالي الإجازة في التحضير، صارت لديك حقيبة رياضيات منظمة لعام دراسي كامل. وقت أكثر لما يهمّ فعلًا:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s45ts71gznwc">
          طلابك. تدريسك. حياتك خارج المدرسة.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="x5v5zq0fi7m0">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="164qg3d6lg1ul">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1646tvk9wurar">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1b1gpxirt217k">دفعة واحدة – بلا اشتراك.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1furz3qk3au2n">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1ktwamnuhl3w5" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1kvftmm7j1t1m">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="1ttjcfar4obpq">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="1tryjtqodj2ui" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}